module.exports = __webpack_public_path__ + "static/media/5.59d7a8c7.jpg";